export default "__VITE_ASSET__qK3x1pa4__"